import { Fun, any } from 'widgets-for-react'
import { CollectionsLoaderState } from '../../../../collections/collectionsLoader/collectionsLoaderState'
import { componentSaverWidget } from '../../../../components/componentSaver/componentSaverWidget'
import { componentTeasersWidget } from '../../../../components/componentTeasers/componentTeasersWidget'
import { ComponentsBlock } from '../../blocksState'
import {
  ComponentsBlockState,
  componentsBlockStateUpdaters,
} from './componentsBlockState'

export const componentsBlockWidget =
  (collectionsState: CollectionsLoaderState, isLoggedIn: boolean) =>
  (block: ComponentsBlock) => {
    const componentSaverState = block.componentsBlocksState.componentSaverState
    return any<
      Fun<
        ComponentsBlockState,
        ComponentsBlockState & { reloadCollections?: boolean }
      >
    >([
      componentSaverWidget(
        collectionsState,
        componentSaverState.opened &&
          block.componentsBlocksState.componentTeasersState.kind == 'loaded'
          ? block.componentsBlocksState.componentTeasersState.value.find(
              (teaser) => teaser.Id === componentSaverState.componentId
            )?.Name
          : undefined
      )(componentSaverState).map(
        componentsBlockStateUpdaters.componentSaverStateUpdater
      ),
      componentTeasersWidget(
        collectionsState,
        'dish-detail',
        isLoggedIn ? 'link-save' : 'link-only',
        {
          title: block.title,
        }
      )(block.componentsBlocksState.componentTeasersState).map(
        componentsBlockStateUpdaters.componentTeasersStateUpdater
      ),
    ])
  }
